<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <div
        v-bind="attrs"
        v-on="on"
      >
        <HeaderActionButton :on-pressed="onPressed">
          <template #icon>
            <v-icon>mdi-book-open-page-variant</v-icon>
          </template>
        </HeaderActionButton>
      </div>
    </template>
    <span>Download User Manual</span>
  </v-tooltip>
</template>

<script>
import HeaderActionButton from "@/views/home/components/HeaderActionButton.vue";

export default {
  name: "UserManualButton",
  components: {
    HeaderActionButton,
  },
  methods: {
    onPressed() {
      const link = document.createElement("a");
      link.href = "/docs/user-manual.pdf";
      link.download = "VesselQUAD-User-Manual.pdf";
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>
